import React, { Component, createRef } from "react";
import { i18next } from "@translations/invenio_app_rdm/i18next";

import { Input, Array } from "react-invenio-forms";
import { Grid, Form, Button, Icon } from "semantic-ui-react";
//import { Dropdown } from "semantic-ui-react";

const newExperiment = {
  program4: "mydefaultvaluebysaif",
  label: "my label",
};

// HANDLE ID

export class Experiments4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
    };
  }

  render() {
    const {
      fieldPath, // injected by the custom field loader via the `field` config property
      program4,
      icon,
      addButtonLabel,
      description,
      label,
    } = this.props;
    console.log(this.props);
    return (
      <span id="handle_id_holder" style={{ display: "none" }}>
        <Input
          ref={this.inputRef}
          fieldPath={`custom_fields.experiments4.program4`}
          label={program4.label}
          placeholder={program4.placeholder}
          description={program4.description}
          disabled={true}
        />
      </span>
    );
  }
}
